<template>
    <div>
        <div>
            <View
                :dataViewDokumenPengadaan="dataViewDokumenPengadaan"
                action="view"
                :header="false"
            >
            </View>
        </div>

        <Divider />
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                <section class="text-gray-600 body-font">
                    <div class="container px-5 py-5 mx-auto">
                        <div class="flex flex-wrap w-full mb-5 flex-col">
                            <div v-show="!loadingPenawaran">
                                <div class="field grid">
                                    <label for="nomor" class="col-12 mb-5 md:col-2 md:mb-0 text-xl">
                                        Pengajuan Penawaran :
                                    </label>
                                    <Divider/>
                                    <div class=" mt-2 field grid align-items-center" style="display: flex; align-items: center;">
                                        <label for="dokumenPenawaran" class="col-3 mb-2 md:col-2 md:mb-0" style="margin-right: 1rem;">Surat Penawaran (PDF):</label>
                                        <FileUpload name="dokumenPenawaran" accept=".pdf" mode="basic" :customUpload="true" :auto="true" @select="onFileSelectDokumenPenawaran" />
                                        <span v-if="form_penawaran.file_dokumen_penawaran" style="margin-left: 1rem; display: flex; align-items: center;">
                                            {{ form_penawaran.file_dokumen_penawaran.name }}
                                            <i class="pi pi-check" style="color: green; margin-left: 0.5rem;"></i>
                                        </span>
                                    </div>
                                    
                                    <div class="mt-2 field grid align-items-center" style="display: flex; align-items: center; margin-top: 1rem;">
                                        <label for="daftarHarga" class="col-3 mb-2 md:col-2 md:mb-0" style="margin-right: 1rem;">Daftar Kuantitas dan Harga (XLSX):</label>
                                        <FileUpload name="daftarHarga" accept=".xlsx" mode="basic" :customUpload="true" :auto="true" @select="onFileSelectDaftarHarga" />
                                        <span v-if="selectedFileName" style="margin-left: 1rem; display: flex; align-items: center;">
    {{ selectedFileName }}
    <i class="pi pi-check" style="color: green; margin-left: 0.5rem;"></i>
</span>
                                    </div>

                                    <div class=" mt-2 field grid align-items-center" style="display: flex; align-items: center;">
                                        <label for="dokumenPenawaran" class="col-3 mb-2 md:col-2 md:mb-0" style="margin-right: 1rem;">Dokumen Penawaran lainnya:</label>
                                        <FileUpload name="dokumenPenawaran" accept=".pdf" mode="basic" :customUpload="true" :auto="true" @select="onFileSelectDokumenPenawaran" />
                                        <!-- <span v-if="form_penawaran.file_dokumen_penawaran" style="margin-left: 1rem; display: flex; align-items: center;">
                                            {{ form_penawaran.file_dokumen_penawaran.name }}
                                            <i class="pi pi-check" style="color: green; margin-left: 0.5rem;"></i>
                                        </span> -->
                                    </div>
                                    <Divider/>
                                    <DataTable :value="form_penawaran.daftar_harga_dan_kuantitas">
                                        <Column field="no" header="NO" />
                                        <Column field="nama" header="Nama" />
                                        <Column field="jumlah" header="Jumlah" />
                                        <Column field="satuan" header="Satuan" />
                                        <Column field="harga" header="Harga" :bodyStyle="{ 'text-align': 'right' }" />
                                    </DataTable>
                                </div>
                                <div class="field grid mt-5">
                                    <div class="col-offset-2">
                                        <Button
                                            icon="pi pi-send"
                                            label="Ajukan Penawaran"
                                            class="p-button p-button-success ml-2"
                                            @click="
                                                submitPenawaran(true)
                                            "
                                            style="float: right;"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="field grid" v-show="loadingPenawaran">
                            <div class="col-12">
                                <ProgressBar
                                    mode="indeterminate"
                                    style="height: 0.5em"
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import readXlsxFile from "read-excel-file";

import AppLayout from "../../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Menubar from "primevue/menubar";
import Textarea from "primevue/textarea";
import AppMenuBar from "../../Components/AppMenuBar.vue";
import DropdownWilayah from "../../Components/DropdownWilayah.vue";
import MapInput from "../../Components/MapInput.vue";
import Calendar from "primevue/calendar";
import { FilterMatchMode } from "primevue/api";
import { useForm } from "@inertiajs/inertia-vue3";
import Column from "primevue/column";
import Button from "primevue/button";
import Divider from "primevue/divider";
import Card from "primevue/card";
import DeleteDialog from "../../Components/DeleteDialog";
import { Inertia } from "@inertiajs/inertia";
import MultiSelect from "primevue/multiselect";
import Dropdown from "primevue/dropdown";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import OverlayPanel from "primevue/overlaypanel";
import FileUpload from "primevue/fileupload";
import pdfvuer from "pdfvuer";
import Dialog from "primevue/dialog";
import ProgressBar from "primevue/progressbar";
import AutoComplete from "primevue/autocomplete";
import RadioButton from "primevue/radiobutton";

import View from "./Penyusunan/View.vue";

import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

// import PermissionTreeTable from '../../Components/PermissionTreeTable';

export default {
    setup: () => ({ vuelidate: useVuelidate() }),
    name: "Index",
    components: {
        Menubar,
        AppMenuBar,
        DataTable,
        Column,
        Button,
        DeleteDialog,
        InputText,
        Password,
        Card,
        Divider,
        MultiSelect,
        Calendar,
        DropdownWilayah,
        Dropdown,
        Accordion,
        AccordionTab,
        MapInput,
        OverlayPanel,
        FileUpload,
        pdf: pdfvuer,
        Dialog,
        ProgressBar,
        AutoComplete,
        Calendar,
        Textarea,
        RadioButton,
        View,
    },
    props: {
        uuid: String,
        dataViewDokumenPengadaan: Object,
        errors: Object,
    },
    watch: {},
    data: function () {
        return {
            selectedFileName: '',
            loadingPenawaran: false,
            submitted: false,
            form_penawaran: {
                file_dokumen_penawaran : null,
                file_daftar_harga_dan_kuantitas : null,
                daftar_harga_dan_kuantitas : [],
            },
            form: {},
        };
    },
    validations() {
        return {
            form_penawaran: {
                penawaran: {
                    required,
                },
            },
        };
    },
    methods: {
        onFileSelectDokumenPenawaran(event) {
            const file = event.files && event.files.length > 0 ? event.files[0] : null;
            if (file) {
                this.form_penawaran.file_dokumen_penawaran = file;
            }
        },
        onFileSelectDaftarHarga(event) {
            const file = event.files && event.files.length > 0 ? event.files[0] : null;
            if (file) {
                this.selectedFileName = file.name;
                this.form_penawaran.file_daftar_harga_dan_kuantitas = file;
                readXlsxFile(file).then((rows) => {
                    const parsedData = rows.slice(2).map((row, index) => ({
                        no: row[0],
                        nama: row[1],
                        jumlah: row[2],
                        satuan: row[3],
                        harga: row[4],
                    }));
                    this.form_penawaran.daftar_harga_dan_kuantitas = parsedData;
                });
            }
        },
        handleFileUpload(event) {
            const file = event.files && event.files.length > 0 ? event.files[0] : null;
            if (file) {
                this.selectedFileName = file.name;
                this.form_penawaran.file_daftar_harga_dan_kuantitas = file;
            }
            console.log("File uploaded", file);
            readXlsxFile(file).then((rows) => {
                const parsedData = rows.slice(2).map((row, index) => ({
                    no: row[0],
                    nama: row[1],
                    jumlah: row[2],
                    satuan: row[3],
                    harga: row[4],
                }));
                this.form_penawaran.daftar_harga_dan_kuantitas = parsedData;
            });
        },
        submitPenawaran(isFormValid) {
            this.loadingPenawaran = true;
            this.submitted = true;

            if (!isFormValid) {
                this.loadingPenawaran = false;
                return;
            }

            this.form_penawaran.uuid = this.uuid;

            // console.log(this.form_penawaran);

            this.$inertia.post("/dokumen_pengadaan/create_penawaran", this.form_penawaran)
                .then((response) => {
                    console.log(response.data);

                    if (response.data.success) {
                        // toast success
                        this.$toast.add({
                            severity: "success",
                            summary: "Berhasil!",
                            detail: response.data.message,
                            life: 3000,
                        });
                    }

                    // emit close-dialong event
                    this.loadingPenawaran = false;
                    this.$emit("closemodal");
                });

            // alert('submitted');
            // alert(this.form)
            // var form_data = {
            //     formAreaLokasi : this.formAreaLokasi,
            //     formMap : this.formMap,
            //     formSertifikatBukuC : this.formSertifikatBukuC,
            //     formTandaBuktiWakaf : this.formTandaBuktiWakaf,
            //     formSuratUkur : this.formSuratUkur,
            //     formAktaIkrarWakaf : this.formAktaIkrarWakaf,
            //     formNazhir : this.formNazhir,
            //     formWakif : this.formWakif,
            //     formSaksi : this.formSaksi,
            // }
            // console.log('halo, sini');

            // console.log(JSON.stringify(this.form));
            // console.log('halo');

            // console.log(this.form);
            // alert('created act!')
            // this.$nextTick(() => {
            //     console.log(this.errors);
            // });
            //
        },
        openPdfViewer(pdf_url) {
            var pdf_data = pdfvuer.createLoadingTask(pdf_url);
            pdf_data.then((pdf) => {
                this.num_pdf_page = pdf.numPages;
                console.log(pdf.numPages);
            });
            this.displayPdfViewer = true;
        },
        closePdfViewer() {
            this.displayPdfViewer = false;
        },
    },
    mounted() {
        // console.log('dataViewDokumenPengadaan', this.dataViewDokumenPengadaan);
    },
    created() {
        this.form = this.dataViewDokumenPengadaan;
    },
};
</script>

<style lang="css" scoped>
.red-radiobutton {
    border-color: #a61900;
    /* background: #a60000; */
}

.red-radiobutton.p-radiobutton-checked .p-radiobutton-box.p-highlight {
    border-color: #a61900 !important;
    background: #a60000 !important;
}
</style>
